
import { css } from 'lit';
export default css`
:host{
  display:inline-block;
}

.btn{
  display:flex;
  justify-content:center;
  align-items:center;
  gap:var(--spacing-2);
  cursor:pointer;
  box-sizing:border-box;
  border:none;
  border-radius:8px;
  padding:8px 16px;
  min-width:208px;
  min-height:44px;
  color:var(--primary-white);
  font-weight:var(--fw-medium);
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
  font-family:var(--ff-body);
  text-decoration:none;
}

.btn:hover{
  display:flex;
  justify-content:center;
  align-items:center;
}

.btn pc-icon{
  display:none;
}

.btn.primary{
  background-color:var(--purple-indigo);
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact;
}

.btn.primary:hover{
  background-color:var(--primary-eggplant);
}

.btn.primary:focus{
  color:var(--primary-eggplant);
  outline:2px solid var(--purple-indigo);
  background-color:var(--purple-indigo-light);
}

.btn.secondary{
  background-color:var(--neutral-light);
  color:var(--purple-indigo);
}

.btn.secondary:hover{
  background-color:var(--purple-indigo);
  color:var(--primary-white);
}

.btn.secondary:focus{
  color:var(--purple-indigo);
  outline:2px solid var(--purple-indigo);
  background-color:var(--neutral-light);
}

@media (min-width: 768px){
  .btn{
    transition:border-radius ease 0.3s, padding-right 0.3s;
    cursor:pointer;
    padding:12px 8px 12px 16px;
    min-width:auto;
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

  .btn pc-icon{
    display:block;
    opacity:0;
    transition:width ease 0.3s, opacity ease 0.3s;
    width:0;
  }

  .btn:hover{
    border-radius:100px;
    padding-right:16px;
  }

  .btn:hover pc-icon{
    opacity:1;
    width:16px;
  }
}
`;